import React from 'react';
import { Provider } from 'react-redux';
import GlobalStyles from '@iso/assets/styles/globalStyle';
import { store } from './redux/store';
import Boot from './redux/boot';
import Routes from './router';
import AppProvider from './AppProvider';
import VersionChecker from './VersionChecker';

const App = () => (
  <div translate="no">
  <Provider store={store}>
    <AppProvider>
      <>
        <VersionChecker />
        <GlobalStyles />
        <Routes />
      </>
    </AppProvider>
  </Provider>
  </div>
);
Boot()
  .then(() => App())
  .catch(error => console.error(error));

export default App;
